import { css } from '@emotion/react';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { type FC } from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { type Theme } from '~/_shared/themes/theme.model';

const itemWidth = 61;

export type SingleItemProps = Readonly<{
  icon: IconProp;
  title: string;
  onClick: () => void;
  isDisabled: boolean;
  fontSize?: string;
  testId?: string;
}>;

export type MobileTopUnderbarButtonProps = Readonly<SingleItemProps & {
  isActive?: boolean;
  className?: string;
}>;

const itemStyles = ({ isDisabled, fontSize }: { isDisabled: boolean; fontSize?: string }) => (theme: Theme) => css({
  display: 'flex',
  backgroundColor: theme.backgroundColors.secondary,
  cursor: isDisabled ? 'default' : 'pointer',
  fontSize,
  height: '100%',

  ':hover': {
    backgroundColor: theme.backgroundColors.tertiary,
  },
});

const menuTileStyle = ({ isActive }: { isActive: boolean }) => (theme: Theme) => {
  let textColor = theme.textColors.primary;
  if (isActive) {
    textColor = theme.iconColors.accented;
  }

  return css({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: isActive ? theme.iconColors.accentedBackground : 'inherit',
    boxSizing: 'border-box',
    color: textColor,
    padding: '0 4px',
    width: itemWidth,
  });
};

const iconStyles = ({ isFocused }: { isFocused: boolean }) => (theme: Theme) => css({
  fontSize: 20,
  fontWeight: 900,
  minWidth: 18,
  color: isFocused ? theme.iconColors.accented : 'inherit',
});

const titleStyle = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  fontSize: 10,
  marginTop: 2,
  textAlign: 'center',
});

export const MobileTopUnderbarButton: FC<MobileTopUnderbarButtonProps> = props => {
  const { onClick } = props;

  return (
    <div
      className={props.className}
      css={itemStyles({ isDisabled: props.isDisabled, fontSize: props.fontSize })}
    >

      <div
        css={menuTileStyle({ isActive: !!props.isActive })}
        onClick={onClick}
        data-testid={props.testId}
      >
        <FontAwesomeIcon
          css={iconStyles({ isFocused: !!props.isActive })}
          icon={props.icon}
        />
        <div css={titleStyle}> {props.title} </div>
      </div>
    </div>
  );
};
